"use client";

import { getGizmoSession } from "@/lib/gizmoSession";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import firebase_app from "@/firebase/config";

// Same pre-payment document and paid fulfillment as the Advanced flow.
// No preliminary analysis or generated previews are needed before checkout.
export async function createColorAnalysisCheckout({ imageData, bucketId, email, cancelPagePath, prePaymentSessionId, onPhotoReady }: {
  imageData: string;
  bucketId: string;
  email: string | null;
  cancelPagePath: string;
  prePaymentSessionId?: string;
  onPhotoReady: (id: string) => void;
}): Promise<string> {
  let sessionId = prePaymentSessionId;
  if (!sessionId) {
    sessionId = `analysis_${crypto.randomUUID()}`;
    const response = await fetch(imageData);
    if (!response.ok) throw new Error("Photo unavailable");
    const blob = await response.blob();
    await uploadBytes(ref(getStorage(firebase_app), `generatedAnalyses/${sessionId}/image_1.png`), blob);
    await setDoc(doc(getFirestore(firebase_app), "generatedColorAnalyses", sessionId), {
      analysisId: sessionId, selectedTier: "full", createdAt: new Date(),
      status: "PENDING_PAYMENT", photoCount: 1, preliminaryResult: null,
    });
    onPhotoReady(sessionId);
  }
  const response = await fetch("/api/stripe/createStripeCheckoutPage", {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ gizmoSession: getGizmoSession(), type: "color-analysis", includeDraping: true,
      prePaymentSessionId: sessionId, bucketId, customerEmail: email, cancelPagePath }),
  });
  const data = await response.json();
  if (!response.ok || typeof data.url !== "string") throw new Error("Checkout unavailable");
  const url = new URL(data.url);
  if (url.protocol !== "https:" || url.hostname !== "checkout.stripe.com") throw new Error("Invalid checkout URL");
  return url.href;
}
